import { Controller } from '@hotwired/stimulus';
import * as bootstrap from 'bootstrap';

class OpenedModalController extends Controller {
  connect() {
    new bootstrap.Modal(this.element).show();
  }
}

export default OpenedModalController;
